export const makePixelsWhite = (pixels: Uint8ClampedArray, opacity = 0.8) => {
  const output = new Uint8ClampedArray(pixels)

  for (let index = 0; index < output.length; index += 4) {
    output[index] = 255
    output[index + 1] = 255
    output[index + 2] = 255
    output[index + 3] = Math.round(output[index + 3] * opacity)
  }

  return output
}

export const createWhiteWatermarkBlob = async (
  source: Blob,
  width = 400,
  height = 225,
  opacity = 0.8
): Promise<Blob> => {
  const sourceUrl = URL.createObjectURL(source)

  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const nextImage = new Image()
      nextImage.onload = () => resolve(nextImage)
      nextImage.onerror = () => reject(new Error('The watermark source could not be decoded'))
      nextImage.src = sourceUrl
    })
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const context = canvas.getContext('2d')

    if (!context) throw new Error('Watermark conversion is unavailable')

    const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight)
    const renderedWidth = image.naturalWidth * scale
    const renderedHeight = image.naturalHeight * scale
    const left = (width - renderedWidth) / 2
    const top = (height - renderedHeight) / 2

    context.clearRect(0, 0, width, height)
    context.drawImage(image, left, top, renderedWidth, renderedHeight)

    const imageData = context.getImageData(0, 0, width, height)
    imageData.data.set(makePixelsWhite(imageData.data, opacity))
    context.putImageData(imageData, 0, 0)

    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('The watermark PNG could not be created'))),
        'image/png'
      )
    })
  } finally {
    URL.revokeObjectURL(sourceUrl)
  }
}
